import { FC } from 'react';

import { DropDownButton } from 'devextreme-react';

import { OptionDropDown } from './hooks/useDropDown';

type Props = {
  data: any;
  actionOptions: Array<OptionDropDown>;
  handleClickDropDown: (option: OptionDropDown, data: any) => void;
};

export const ActionsRow: FC<Props> = ({ actionOptions, data, handleClickDropDown }) => {
  return (
    <DropDownButton
      icon="overflow"
      items={actionOptions}
      onItemClick={(e) => handleClickDropDown(e.itemData, data.data)}
      dropDownOptions={{
        width: 200,
      }}
      className="dropdown-dots"
      displayExpr="name"
      keyExpr="id"
      onButtonClick={(e) => {
        e.event?.stopPropagation();
      }}
    />
  );
};
